export default {
  SITE_NAME: 'Texas by Texas',
  SITE_NAME_ABBR: 'TxT',
  HELP_DESK_PHONE: '1-877-452-9060',
};
